export const RESTRICTED_DOWNLOAD_LABELS = ['High Resolution (1080p)', 'High Resolution', 'Original Resolution'];